<template>
  <div class="generic-dropdown">
    <label class="label" v-if="$props.show_title">{{ $props.title }}</label>
    <div
      class="ui selection search dropdown input"
      ref="dropdown"
      v-bind:class="{
        multiple: $props.is_multiple,
        inverted: $props.is_inverted,
      }"
    >
      <input type="hidden" />
      <i class="dropdown icon"></i>
      <div class="default text">{{ $props.placeholder }}</div>
    </div>
  </div>
</template>

<script>
import { get_user_data, session_token, api_host } from "@/utils";

export default {
  name: "GenericDropdown",
  props: {
    is_multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
    },
    url: {
      type: String,
      required: true,
    },
    name_field: {
      type: String,
      required: false,
      // required: true,
    },
    display_text: {
      type: Function,
      required: false,
      default: null,
    },
    value_field: {
      type: String,
      required: true,
    },
    display_function: {
      type: Function,
      required: false,
      default: null,
    },
    show_title: {
      type: Boolean,
      required: false,
      default: true,
    },
    extra_data: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    add_new: {
      type: Boolean,
      required: false,
      default: false,
    },
    is_inverted: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    clear() {
      window.jQuery(this.$refs.dropdown).dropdown("clear");
    },
    set_value(value) {
      // console.log("value", value);
      window.jQuery(this.$refs.dropdown).dropdown(
        "show",
        () => {
          window.jQuery(this.$refs.dropdown).dropdown("set selected", value);
          window.jQuery(this.$refs.dropdown).dropdown("hide");
        },
        true
      );
    },
    init() {
      let v = this;
      let user_data = get_user_data();

      let _r = [];
      window.jQuery(v.$refs.dropdown).dropdown({
        onChange(value) {
          // console.log("value", value);
          let vls = value.split(",").map((v) => {
            return String(v);
          });

          if (vls.includes("add_new")) {
            v.$emit("add_new");
            return;
          }

          // console.log("vls", vls);
          // console.log("_r", _r);
          v.$emit("change", vls);
          let trgt = _r.filter((x) => {
            return vls.includes(String(x[v.value_field]));
          });

          if (trgt) {
            if (trgt.length == 0) v.$emit("selected", null);
            if (trgt.length == 1) v.$emit("selected", trgt[0]);
            else v.$emit("selected", trgt);
          } else console.log("no target found.... weird");
        },
        apiSettings: {
          url: v.url.startsWith("http") ? v.url : `${api_host}${v.url}`,
          cache: false,
          saveRemoteData: false,
          beforeSend: function (settings) {
            settings.data = { q: settings.urlData.query, ...v.extra_data };
            v.$emit("before_send", settings);
            return settings;
          },
          beforeXHR: function (xhr) {
            let token = session_token();
            if (token) xhr.setRequestHeader("modul-access-token", token);
            if (user_data.enterprise_name)
              xhr.setRequestHeader("enterprise", user_data.enterprise_name);
            return xhr;
          },
          onResponse: function (response) {
            _r = response;
            let results = [];
            if (response && response) {
              results = response.map((item) => {
                if (v.display_function) {
                  let name = v.display_function(item);
                  return {
                    name: name,
                    value: item[v.value_field],
                  };
                } else {
                  let display_source = v.name_field
                    ? item[v.name_field]
                    : v.display_text
                    ? v.display_text(item)
                    : "";
                  return {
                    // name: item[v.name_field],
                    name: display_source,
                    value: item[v.value_field],
                  };
                }
              });
            }

            if (v.add_new) {
              results.push({
                name: v.$t("add new"),
                value: "add_new",
              });
            }

            return {
              success: true,
              results: results,
            };
          },
        },
      });
    },
  },
  mounted() {
    let v = this;
    v.init();
  },
};
</script>

<style></style>
